import { render, staticRenderFns } from "./RecursiveTable.vue?vue&type=template&id=51215c97&"
import script from "./RecursiveTable.vue?vue&type=script&lang=js&"
export * from "./RecursiveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports